import React from "react";
import {
  Button,
  Group,
  Title,
  Stack,
  Divider,
  rem,
  Switch,
} from "@mantine/core";
import { createTrainingSet } from "../api";
import {
  IconCoins,
  IconDeselect,
  IconTrash,
  IconUserPlus,
} from "@tabler/icons-react";
import mixpanel from "mixpanel-browser";
import { notifications } from "@mantine/notifications";
import { useStore } from "../store";
import { useLocation } from "wouter";

const isDev = import.meta.env.VITE_DEV === "true";

let baseOperations = [
  { id: "removebg", label: "Remove Background", credits: 30 },
  { id: "upscale", label: "Upscale", credits: 30 },
];

if (isDev) {
  baseOperations = [
    ...baseOperations,
    { id: "test", label: "Test", credits: 1 },
  ];
  console.debug(
    "Development mode, addded test ot baseOperations",
    baseOperations
  );
}

export default function BulkEditActions() {
  const selectedImages = useStore((state) => state.selectedImages);
  const setSelectedImages = useStore((state) => state.setSelectedImages);
  const showSelectedOnly = useStore((state) => state.showSelectedOnly);
  const setShowSelectedOnly = useStore((state) => state.setShowSelectedOnly);

  const jobs = useStore((state) => state.jobs);
  const setJobs = useStore((state) => state.setJobs);

  const plugins = useStore((state) => state.pluginData);
  const [, setLocation] = useLocation();

  const galleryImages = useStore((state) => state.galleryImages);

  function getPixelImage(logicalImageId) {
    // add the thumbnail uri to the job / background image
    try {
      console.debug("Looking for gallery image / thumbnail", logicalImageId);
      console.debug("galleryImages is", galleryImages);

      var fullGalleryImage = galleryImages.data.find(
        (p) => p.logicalImageId === logicalImageId
      );
      console.debug("fullGalleryImage", fullGalleryImage);
      if (fullGalleryImage) {
        const pixelImage = fullGalleryImage.pixelImages.find(
          (p) => p.type === "Thumbnail"
        );
        return pixelImage.uri;
        // data = { ...data, uri: pixelImage.uri };
      }
    } catch (e) {
      console.debug("failed to add img uri", e);
      return null;
    }
  }

  function createClientJob(operation, logicalImageId) {
    // Get the image URI for the background image...
    var imageUri = getPixelImage(logicalImageId);
    return {
      uri: imageUri,
      status: "Waiting", // 'queued' is used server-side
      operation,
      image: logicalImageId,
      clientId: Math.random().toString(36).substr(2, 9),
    };
  }

  const applyOperation = (operation) => {
    try {
      mixpanel.track("applyOperation batch called", {
        batchSize: selectedImages.length,
        operationId: operation.id,
        pluginId: operation.pluginId,
      });
    } catch {}

    const newItems = selectedImages.map((image) =>
      createClientJob(operation, image)
    );
    setJobs([...jobs, ...newItems]);
  };

  let operations = [...baseOperations];
  if (plugins) {
    var fmap = plugins.flatMap((p) => p.actions);
    operations = operations.concat(fmap);
  }

  return (
    <Stack p="xs">
      <Title order={2} mb="sm">
        Bulk Edit
      </Title>
      {operations.map((operation) => (
        <Button
          key={operation.id}
          variant="default"
          size="xs"
          disabled={selectedImages.length === 0}
          onClick={() => applyOperation(operation)}
          rightSection={
            <Group gap={4}>
              <IconCoins
                stroke={1.5}
                style={{ width: rem(12), height: rem(12) }}
              />{" "}
              {operation.credits * selectedImages.length}
            </Group>
          }
          // loading={isPolling}
          loaderProps={{ type: "dots" }}
        >
          {operation.label}
        </Button>
      ))}

      <Button
        onClick={() => {
          setSelectedImages([]);
          setShowSelectedOnly(false);
        }}
        variant="default"
        size="xs"
        disabled={selectedImages.length === 0}
        leftSection={
          <IconDeselect style={{ width: rem(14), height: rem(14) }} />
        }
      >
        Deselect all
      </Button>

      <Switch
        label="Show selected only"
        variant="default"
        size="xs"
        checked={showSelectedOnly}
        disabled={selectedImages.length === 0}
        onChange={(event) => setShowSelectedOnly(event.currentTarget.checked)}
      />

      <Button
        variant="default"
        size="xs"
        disabled={selectedImages.length === 0}
        onClick={() => {
          createTrainingSet(selectedImages)
            .then((data) => {
              notifications.show({
                title: "Success",
                message: "Training set created",
                color: "green",
              });
              setLocation(`/training-datasets/${data.id}`);
            })
            .catch((error) => {
              notifications.show({
                title: "An error occurred",
                message: "" + error,
                color: "red",
              });
            });
        }}
        leftSection={
          <IconUserPlus style={{ width: rem(14), height: rem(14) }} />
        }
      >
        Create model
      </Button>
      {/* <Divider />
      <Button
        variant="default"
        size="xs"
        leftSection={<IconTrash style={{ width: rem(14), height: rem(14) }} />}
        onClick={() => {}}
        disabled={selectedImages.length === 0}
      >
        Delete selected
      </Button> */}
    </Stack>
  );
}
